import React, { useContext } from 'react'
import { AppStateContext } from '../AppStateContext'
import { FaPrint, FaTimes } from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import TimeWindowSelectorButton from '../../../elem/chart/TimeWindowSelectorButton'
import ResetZoomButton from '../../../elem/chart/ResetZoomButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'

export default ({ chartRef }) => {
    const { updateDetailState } = useContext(AppStateContext)
    const {
        timeWindow,
        displayTimeWindowDropdown,
        toggleTimeWindowDropdown,
        resetZoom,
        detailData,
        isLoading,
    } = useContext(DataContext)

    return (
        <PanelHeader extraClass="wellDetailPanelHeader">
            <div className="panelHeaderText">Details</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name='DetailsMenuNitrateChart'
                    componentRef={chartRef}
                    disabled={
                        isLoading ||
                        !(
                            detailData &&
                            detailData.nitrateChart &&
                            detailData.nitrateChart.length
                        )
                    }
                />
                <ResetZoomButton resetFunction={resetZoom} />
                <TimeWindowSelectorButton
                    timeWindow={timeWindow}
                    displayTimeWindowDropdown={displayTimeWindowDropdown}
                    toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                />
                <div
                    className="panelButton"
                    onClick={e => {
                        e.preventDefault()
                        updateDetailState('well', { visible: false })
                    }}
                >
                    <FaTimes />
                </div>
            </div>
        </PanelHeader>
    )
}
